import axios from 'axios';
import { getAuthHeader } from './authApi';

/**
 * Interface for general bet data
 */
export interface GeneralBet {
  id?: number;
  user_id?: number;
  bet_id: number;
  prediction: any;
  success?: boolean;
}

/**
 * Interface for bet prediction entry
 */
export interface BetPrediction {
  bet_id: number;
  prediction: any;
}

/**
 * Get all user's general bets
 */
export const getUserGeneralBets = async (): Promise<GeneralBet[]> => {
  try {
    const response = await axios.get('/api/user/bets/general', {
      headers: getAuthHeader()
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching general bets:', error);
    return [];
  }
};

/**
 * Get general bets for a specific user by ID
 */
export const getUserGeneralBetsByUserId = async (userId: number): Promise<GeneralBet[]> => {
  try {
    const response = await axios.get(`/api/users/${userId}/bets/general`, {
      headers: getAuthHeader()
    });
    return response.data || [];
  } catch (error) {
    console.error(`Error fetching general bets for user ${userId}:`, error);
    return [];
  }
};

/**
 * Place or update a general bet - Single prediction version
 * @deprecated Use placeBatchGeneralBets instead
 */
export const placeGeneralBet = async (betId: number, prediction: any): Promise<GeneralBet> => {
  try {
    const response = await axios.post('/api/user/bets/general', {
      bet_id: betId,
      prediction
    }, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error placing general bet:', error);
    throw error;
  }
};

/**
 * Place or update multiple general bets in a transaction
 * This will delete all existing bets with the same bet_id and insert the new ones
 */
export const placeBatchGeneralBets = async (betId: number, predictions: any[]): Promise<GeneralBet[]> => {
  try {
    // Send the predictions directly without wrapping in bet_id objects
    // The server expects an array of prediction objects
    const response = await axios.post('/api/user/bets/general/batch', {
      bet_id: betId,
      predictions: predictions
    }, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error placing batch general bets:', error);
    throw error;
  }
};

/**
 * Delete a general bet
 */
export const deleteGeneralBet = async (betId: number): Promise<void> => {
  try {
    await axios.delete(`/api/user/bets/general/${betId}`, {
      headers: getAuthHeader()
    });
  } catch (error) {
    console.error('Error deleting general bet:', error);
    throw error;
  }
}; 